import { getOauth } from '@/service/base'
export default {
    onLoadData: (options, wxCallbackUrl, callback) => {
        console.log('onLoadData options', options)
        let code = options.code && options.code.split(',')[options.code.split(',').length - 1]
        console.log('onLoadData', code)
        if (!code) {
            code = uni.$u.getUrlParam(window.location.href, 'code')
            console.log('uni.$u.getUrlParam', code)
        }
        let isWx = uni.$u.browser().weixin
        let openid = ""
        let currOpenid = localStorage.getItem('openid')
        if (!isWx) {
            currOpenid = 'o0MPV6k-wfpAVCy2QKod8M7DBtqc'
        }
        console.log('currOpenid', currOpenid)
        if (!uni.$u.isEmpty(code)) {
            console.log('!uni.$u.isEmpty(code)', code)
            this.getWxOpenId(code, callback)
            openid = ''
        } else if (isWx) {
            if (!currOpenid) {
                uni.$u.toWeiXinAuthLoginByUrl(window.location.origin + callbackUrl)
            } else {
                openid = currOpenid
            }
        } else if (currOpenid) {
            openid = currOpenid
        }
        return openid
    },
    getWxOpenId: (code, callback) => {
        console.log('getWxOpenId', code)
        getOauth(code)
            .then((res) => {
                console.log('getWxOpenId getOauth', res)
                if (res.success && res.result.openid) {
                    localStorage.setItem('openid', res.result.openid)
                    callback && callback(res.result.openid)
                } else {
                    uni.$u.toast(res.message)
                }
            })
            .catch((err) => {
                uni.hideLoading()
                uni.$u.toast(err.message)
            })
    }
}